/* Lunaire: route all add-to-cart flows into the cart drawer instead of the /cart page.
   - Intercepts native product form submits (the {% form 'product' %} PDP forms).
   - Exposes window.lunaireOpenCartDrawer() for custom ATC code (ritual bundle pages).
   Falls back to the default /cart redirect when the drawer isn't on the page. */
(function () {
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  /* success pulse for the ATC button */
  var st = document.createElement('style');
  st.textContent =
    '@keyframes lunaireAtcPulse{0%{box-shadow:0 0 0 0 rgba(184,150,62,.5)}100%{box-shadow:0 0 0 16px rgba(184,150,62,0)}}' +
    '.lunaire-atc-added{animation:lunaireAtcPulse .9s ease-out 1}';
  document.head.appendChild(st);

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  /* Re-fetch the drawer + header bubble sections, inject them, open the drawer. */
  window.lunaireOpenCartDrawer = function () {
    var drawer = getDrawer();
    if (!drawer) {
      window.location.href = '/cart';
      return;
    }
    fetch('/?sections=' + SECTIONS)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        drawer.renderContents({ sections: sections });
      })
      .catch(function () {
        window.location.href = '/cart';
      });
  };

  /* Delegated interceptor for plain product forms (action="/cart/add").
     Skips if another handler (e.g. Dawn's product-form) already claimed the submit. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented) return;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var drawer = getDrawer();
    if (!drawer) return; // no drawer on page: keep default behavior

    event.preventDefault();

    var submitBtn = form.querySelector('[name="add"], [type="submit"]');
    var oldText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.textContent = 'Adding…'; submitBtn.disabled = true; }

    var formData = new FormData(form);
    formData.append('sections', SECTIONS);
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status && response.status !== 200) {
          throw new Error(response.description || 'Could not add to cart');
        }
        var drawerNow = getDrawer();
        if (drawerNow && response.sections) {
          drawerNow.renderContents(response);
        } else {
          window.lunaireOpenCartDrawer();
        }
        if (submitBtn) {
          submitBtn.textContent = 'Added ✦';
          submitBtn.classList.add('lunaire-atc-added');
          setTimeout(function () {
            submitBtn.textContent = oldText;
            submitBtn.disabled = false;
            submitBtn.classList.remove('lunaire-atc-added');
          }, 1400);
        }
      })
      .catch(function (e) {
        if (submitBtn) { submitBtn.textContent = oldText; submitBtn.disabled = false; }
        alert(e && e.message ? e.message : 'Could not add to cart. Please try again.');
      });
  });
})();
